
import { WorldCountry } from '../types';
import { mexicoAdditionalCities } from './mexicoExpansion';

export const mexicoData: WorldCountry = {
  code: 'MX',
  name: 'Mexico',
  slug: 'mexico',
  population: 128932753,
  topCities: [
    { name: 'Mexico City', slug: 'mexico-city', population: 9209944 },
    { name: 'Tijuana', slug: 'tijuana', population: 1810645 },
    { name: 'Ecatepec', slug: 'ecatepec', population: 1645352 },
    { name: 'León', slug: 'leon-mexico', population: 1238962 },
    { name: 'Puebla', slug: 'puebla', population: 1434062 },
    { name: 'Ciudad Juárez', slug: 'ciudad-juarez', population: 1501551 },
    { name: 'Guadalajara', slug: 'guadalajara', population: 1385629 },
    { name: 'Zapopan', slug: 'zapopan', population: 1476491 },
    { name: 'Monterrey', slug: 'monterrey', population: 1135550 },
    { name: 'Nezahualcóyotl', slug: 'nezahualcoyotl', population: 1077208 },
    { name: 'Chihuahua', slug: 'chihuahua', population: 925762 },
    { name: 'Naucalpan', slug: 'naucalpan', population: 833779 },
    { name: 'Mérida', slug: 'merida', population: 892363 },
    { name: 'Álvaro Obregón', slug: 'alvaro-obregon', population: 749982 },
    { name: 'San Luis Potosí', slug: 'san-luis-potosi', population: 824229 },
    { name: 'Aguascalientes', slug: 'aguascalientes', population: 948990 },
    { name: 'Hermosillo', slug: 'hermosillo', population: 936263 },
    { name: 'Cancún', slug: 'cancun', population: 628306 },
    { name: 'Saltillo', slug: 'saltillo-original', population: 823128 },
    { name: 'Culiacán', slug: 'culiacan', population: 858638 },
    { name: 'Chimalhuacán', slug: 'chimalhuacan', population: 614453 },
    { name: 'Tlaquepaque', slug: 'tlaquepaque', population: 664193 },
    { name: 'Morelia', slug: 'morelia', population: 597511 },
    { name: 'Veracruz', slug: 'veracruz', population: 607209 },
    { name: 'Mexicali', slug: 'mexicali', population: 1049792 },
    { name: 'Acapulco', slug: 'acapulco', population: 779566 },
    { name: 'Tlalnepantla', slug: 'tlalnepantla-original', population: 700734 },
    { name: 'Guadalupe', slug: 'guadalupe-nuevo-leon-original', population: 678006 },
    { name: 'Puebla', slug: 'puebla-city', population: 1434062 },
    { name: 'Tuxtla Gutiérrez', slug: 'tuxtla-gutierrez-original', population: 598710 },
    { name: 'Ciudad Victoria', slug: 'ciudad-victoria-original', population: 365089 },
    { name: 'Irapuato', slug: 'irapuato-original', population: 380941 },
    { name: 'Reynosa', slug: 'reynosa-original', population: 704767 },
    { name: 'Xalapa', slug: 'xalapa-original', population: 488531 },
    { name: 'Tonalá', slug: 'tonala-original', population: 593616 },
    { name: 'Cuauhtémoc', slug: 'cuauhtemoc-original', population: 168482 },
    { name: 'Oaxaca', slug: 'oaxaca', population: 263357 },
    { name: 'Cuernavaca', slug: 'cuernavaca-original', population: 366321 },
    { name: 'Tlajomulco de Zúñiga', slug: 'tlajomulco-de-zuniga-original', population: 549442 },
    { name: 'Nuevo Laredo', slug: 'nuevo-laredo-original', population: 425058 },
    { name: 'Pachuca', slug: 'pachuca-original', population: 277375 },
    { name: 'Celaya', slug: 'celaya-original', population: 521169 },
    { name: 'Mazatlán', slug: 'mazatlan-original', population: 438434 },
    { name: 'Tepic', slug: 'tepic-original', population: 396667 },
    { name: 'Ensenada', slug: 'ensenada-original', population: 486639 },
    { name: 'Victoria de Durango', slug: 'victoria-de-durango-original', population: 688697 },
    { name: 'Ciudad López Mateos', slug: 'ciudad-lopez-mateos-original', population: 489160 },
    { name: 'Heroica Matamoros', slug: 'heroica-matamoros-original', population: 541979 },
    { name: 'La Paz', slug: 'la-paz-mexico-original', population: 290286 },
    { name: 'San Luis Río Colorado', slug: 'san-luis-rio-colorado-original', population: 192739 },
    
    // Agregar las 100 ciudades adicionales de la expansión
    ...mexicoAdditionalCities
  ]
};
